import { action } from 'typesafe-actions';
import { MapLocationSearchActionTypes } from './types';

export const getAddressSuggestStart = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_SUGGESTION_START, payload);
export const getAddressSuggestSuccess = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_SUGGESTION_SUCCESS, payload);
export const getAddressSuggestFailure = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_SUGGESTION_FAILURE, payload);
export const clearAddressSuggest = () =>
  action(MapLocationSearchActionTypes.CLEAR_ADDRESS_SUGGESTION);
export const getAddressCandidateStart = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_START, payload);
export const getAddressCandidateSuccess = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_SUCCESS, payload);
export const getAddressCandidateFailure = (payload: string) =>
  action(MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_FAILURE, payload);
export const clearAddressCandidate = () =>
  action(MapLocationSearchActionTypes.CLEAR_ADDRESS_CANDIDATE);
export const getLotNumSuggestStart = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_LOT_NUM_SUGGESTION_START, payload);
export const getLotNumSuggestSuccess = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_LOT_NUM_SUGGESTION_SUCCESS, payload);
export const getLotNumSuggestFailure = (payload: any) =>
  action(MapLocationSearchActionTypes.GET_LOT_NUM_SUGGESTION_FAILURE, payload);
